import { FormEvent } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ErrorAlert from '@/shared/components/ErrorAlert';
import FormField from '@/shared/components/FormField';
import FormInput from '@/shared/components/FormInput';
import Button from '@/shared/components/Button';

interface Props {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  error: string | null;
  isLoading: boolean;
  onCurrentPasswordChange: (value: string) => void;
  onNewPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  onSubmit: (event: FormEvent) => void;
}

export default function ChangePasswordForm({
  currentPassword,
  newPassword,
  confirmPassword,
  error,
  isLoading,
  onCurrentPasswordChange,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
}: Props) {
  const intl = useIntl();

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-slate-900">
        <FormattedMessage id="settings.changePassword.heading" />
      </h2>

      {error && <ErrorAlert message={error} />}

      <form className="space-y-5" onSubmit={onSubmit}>
        <FormField id="currentPassword" labelId="settings.changePassword.currentPasswordLabel">
          <FormInput
            id="currentPassword"
            type="password"
            autoComplete="current-password"
            required
            placeholder={intl.formatMessage({ id: 'settings.changePassword.currentPasswordPlaceholder' })}
            value={currentPassword}
            onChange={(e) => onCurrentPasswordChange(e.target.value)}
          />
        </FormField>

        <FormField id="newPassword" labelId="settings.changePassword.newPasswordLabel">
          <FormInput
            id="newPassword"
            type="password"
            autoComplete="new-password"
            required
            placeholder={intl.formatMessage({ id: 'settings.changePassword.newPasswordPlaceholder' })}
            value={newPassword}
            onChange={(e) => onNewPasswordChange(e.target.value)}
          />
        </FormField>

        <FormField id="confirmPassword" labelId="settings.changePassword.confirmPasswordLabel">
          <FormInput
            id="confirmPassword"
            type="password"
            autoComplete="new-password"
            required
            placeholder={intl.formatMessage({ id: 'settings.changePassword.confirmPasswordPlaceholder' })}
            value={confirmPassword}
            onChange={(e) => onConfirmPasswordChange(e.target.value)}
          />
        </FormField>

        <Button type="submit" disabled={isLoading} fullWidth>
          {isLoading ? (
            <FormattedMessage id="settings.changePassword.submitting" />
          ) : (
            <FormattedMessage id="settings.changePassword.submit" />
          )}
        </Button>
      </form>
    </div>
  );
}
